/*
 * File: TaskTabColumn.tsx
 * Project: a-a
 * File Created: Monday, 16th December 2024 6:47:54 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 28th July 2025 2:50:35 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { LightTooltip } from '../../CustomTooltip/CustomTooltip';
import zeplinColor from '../../../../theme/Color';
import CustomPopOver from '../../CustomPopOver/CustomPopOver';
import InfiniteScrollColumn from '../../InfiniteScrollColumn/InfiniteScrollColumn';
import TaskCard from '../Overview/Tasks/TaskCard/TaskCard';
import CustomViewTask from '../../CustomViewTask/CustomViewTask';
import { useLocation } from 'react-router-dom';
import styles from './TaskTabColumn.module.css';
const TaskTabColumn = ({
  data,
  loading,
  getTask,
  tabTitle,
  ellipse,
  setAction,
  action,
  setEdit,
  setViewDrawerState,
  viewDrawerState,
}: // handleClose,
{
  data: {
    done: number;
    totalRecords: number;
    records: never[];
    service: string;
    inProgress: number;
    todo: number;
    totalFilteredRecords: number;
  };
  loading: boolean;
  getTask: (next?: boolean) => Promise<void>;
  tabTitle: string;
  ellipse: string;
  setAction: React.Dispatch<React.SetStateAction<string>>;
  action: string;
  setEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setViewDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  viewDrawerState: boolean;
  // handleClose: () => void;
}) => {
  const taskFromOverview = sessionStorage.getItem('openTask') || '';
  const location = useLocation(); // Get the current location object
  const isTeamPath = location.pathname.includes('team'); // Check if pathname contains "team"

  const sf_edit = sessionStorage.getItem('sf_edit') || '';
  const sf_notes_id = sessionStorage.getItem('notes_id') || '';
  const sf_task_status = sessionStorage.getItem('sf_task_status') || '';
  const sf_delete = sessionStorage.getItem('sf_delete') || '';
  const sf_marked = sessionStorage.getItem('sf_marked') || '';
  const notesContent = sessionStorage.getItem('notes_content') || '';
  const sf_edit_selected = sessionStorage.getItem('sf_edit_selected') || '';
  let parsed_selected = {
    assignedTo: '',
    createdDate: '',
    decription: '',
    dueDate: '',
    isOverdue: true,
    link: '',
    name: '',
    nameType: '',
    priority: 'Normal',
    relatedTo: '',
    relatedToType: '',
    status: 'Not Started',
    subject: '',
    id: '',
  };
  // const [alert, setAlert] = React.useState('');
  const [selected, setSelected] = useState(parsed_selected);
  if (sf_edit_selected) {
    parsed_selected = JSON.parse(sf_edit_selected);
  }
  const screenHeight = window.innerHeight;

  // const handleClose = () => {
  //   setAlert('');
  // };
  const renderTaskCard = (val: any) => (
    <Box
      onClick={() => {
        setViewDrawerState(true);

        setSelected(val);
      }}
    >
      <TaskCard data={val} loading={loading} />
    </Box>
  );
  useEffect(() => {
    if (taskFromOverview && data?.records?.length) {
      const taskData = taskFromOverview;
      const selectedFound = data?.records?.filter((val: any) => val.id === taskData);
      console.log({ selectedFound, taskFromOverview });
      setSelected(selectedFound[0]);
      setViewDrawerState(true);
    }
  }, [taskFromOverview, data?.records]);

  useEffect(() => {
    if (
      (sf_edit === 'true' ||
        sf_delete === 'true' ||
        sf_marked === 'true' ||
        notesContent ||
        sf_notes_id) &&
      !viewDrawerState
    ) {
      const currentTabRender =
        tabTitle === 'To Do' ? 'Not Started' : tabTitle === 'Done' ? 'Completed' : tabTitle;
      currentTabRender === sf_task_status && setViewDrawerState(true);
      // console.log({ drawerconsole: true });
    }
  }, []);

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: '10px', xl: '16px' },
        // height: '100vh',
        // paddingBottom: '20rem',
        // flexGrow: 1,
        // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
        // height: screenHeight > 640 ? '39vh' : '37vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: { xs: '6px', xl: '12px' },
        }}
      >
        <Typography
          variant='responsiveHeading3'
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <img src={`/assets/${ellipse}`} width={8} height={8} /> {tabTitle} (
          {/* {tabTitle === 'Done'
            ? data['done']
            : tabTitle === 'In Progress'
            ? data['inProgress']
            
            : data['todo']} */}
          {data?.totalFilteredRecords})
        </Typography>
      </Box>
      {/* <InfiniteScrollColumn content={<Column />} dataVal={data} /> */}

      {data?.totalFilteredRecords <= 0 && loading ? (
        <Box
          sx={{
            display: 'flex',

            flexDirection: 'column',
            flex: 1,

            gap: { xs: '10px', xl: '16px' },
            // overflow: 'auto',
            // height: screenHeight > 640 ? '39vh' : '37vh',
            height: isTeamPath ? 'calc(100vh - 350px)' : 'calc(100vh - 400px)',
            // paddingBottom: '20rem',
          }}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((val: any, ind: number) => (
            <TaskCard data={val} loading={true} key={ind} />
          ))}
        </Box>
      ) : data?.totalFilteredRecords <= 0 && !loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            // flex: 1,
            // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
            // height:
            //   screenHeight > 1200
            //     ? '60vh'
            //     : screenHeight > 1100
            //     ? '57vh'
            //     : screenHeight > 1000
            //     ? '52vh'
            //     : screenHeight > 900
            //     ? '48vh'
            //     : screenHeight > 800
            //     ? '43vh'
            //     : screenHeight > 700
            //     ? '35vh'
            //     : screenHeight > 600
            //     ? '20vh'
            //     : '5vh',
            height: isTeamPath ? 'calc(100vh - 350px)' : 'calc(100vh - 400px)',
          }}
        >
          {' '}
          <img src={'/assets/no-tasks.svg'} className={styles['no-tasks-icon']} />
          <Typography
            variant='responsiveHeading3'
            color={zeplinColor.BasicBlack}
            sx={{ marginTop: '24px' }}
          >
            No Tasks Yet
          </Typography>
          <Typography
            variant='responsiveBody3'
            color={zeplinColor.Neutral8}
            sx={{ width: '70%', textAlign: 'center', marginTop: '12px' }}
          >
            Looks like there's nothing left to do. New task will appear here once added.
          </Typography>
        </Box>
      ) : (
        ''
      )}
      <InfiniteScrollColumn
        dataVal={data}
        render={renderTaskCard}
        // height={
        //   '100vh'
        //   // screenHeight > 1200
        //   //   ? '60vh'
        //   //   : screenHeight > 1100
        //   //   ? '57vh'
        //   //   : screenHeight > 1000
        //   //   ? '52vh'
        //   //   : screenHeight > 900
        //   //   ? '48vh'
        //   //   : screenHeight > 800
        //   //   ? '43vh'
        //   //   : screenHeight > 700
        //   //   ? '35vh'
        //   //   : screenHeight > 600
        //   //   ? '20vh'
        //   //   : '5vh'
        // }
        height={
          window.innerWidth > 1700
            ? isTeamPath
              ? 'calc(100vh - 380px)'
              : 'calc(100vh - 430px)'
            : isTeamPath
            ? 'calc(100vh - 325px)'
            : 'calc(100vh - 360px)'
        }
        paddingBottom='0rem'
        next={(offset) => getTask(offset)}
        total={
          // tabTitle === 'Done'
          //   ? data['done']
          //   : tabTitle === 'In Progress'
          //   ? data['inProgress']
          //   : data['todo']
          data.totalFilteredRecords
        }
        loading={loading}
      />

      {(selected?.link || parsed_selected?.link || notesContent || sf_notes_id) && (
        <CustomViewTask
          setDrawerState={setViewDrawerState}
          drawerState={viewDrawerState}
          selectedData={selected?.link ? selected : parsed_selected}
          setDeleted={setAction}
          setEditDone={setEdit}
          setSelected={setSelected}
        />
      )}
    </Box>
  );
};

export default TaskTabColumn;
